import { render, staticRenderFns } from "./reset-password-request.vue?vue&type=template&id=1180de4c&scoped=true"
import script from "./reset-password-request.vue?vue&type=script&lang=js"
export * from "./reset-password-request.vue?vue&type=script&lang=js"
import style0 from "./reset-password-request.vue?vue&type=style&index=0&id=1180de4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1180de4c",
  null
  
)

export default component.exports